/**
 * Lenis smooth scroll (Lenis is loaded from CDN on `globalThis.Lenis`).
 * Uses GSAP ticker when available so ScrollTrigger stays in sync.
 */
export function initLenisSmoothScroll() {
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) {
    return null;
  }

  const LenisCtor = globalThis.Lenis;
  if (!LenisCtor) {
    return null;
  }

  const lenis = new LenisCtor({
    smoothWheel: true,
    lerp: 0.08,
    wheelMultiplier: 0.9,
    touchMultiplier: 1,
    anchors: true,
    syncTouch: false
  });

  if (typeof ScrollTrigger !== "undefined" && ScrollTrigger.update) {
    lenis.on("scroll", ScrollTrigger.update);
  }

  const gsap = globalThis.gsap;
  if (gsap?.ticker) {
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  } else {
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  if (typeof ScrollTrigger !== "undefined" && ScrollTrigger.refresh) {
    requestAnimationFrame(() => {
      ScrollTrigger.refresh();
    });
  }

  return lenis;
}


// duration: 1.1,
// wheelMultiplier: 1.0,

// duration: 0.9,
// wheelMultiplier: 1.15,

// duration: 0.7,
// wheelMultiplier: 1.3

// If you want speed + premium ease feel, keep your easing as-is:
// easing: (t) => 1 - Math.pow(1 - t, 3),